<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.manage study") }}</h2>
    </div>
    <div class="col-lg-2">
       <span class="tooltip-wrapper pointer" style="float:right">
      <i class="fa fa-times close" @click="onclosed()"></i>
       <span class="custom-tooltip closetooltipposition">Close</span>
  </span>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content p-3">
      <div class="form-group row">
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.study id") }}
            <sup><i class="fa fa-asterisk imp"></i></sup
          ></label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.studyRef"
          />
          <span class="errormsg" v-if="errors[1] == false">{{
            $t("navigations.please enter a study id")
          }}</span>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">
            {{ $t("navigations.study name")
            }}<sup><i class="fa fa-asterisk imp"></i></sup
          ></label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.studyName"
          />
          <span class="errormsg" v-if="errors[0] == false">{{
            $t("navigations.please enter a study name")
          }}</span>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">{{ $t("navigations.sponsor") }} </label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.sponsor"
          />
        </div>

        <div class="col-lg-3 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.study type") }}</label
          >
          <select class="form-select" v-model="selectedStudyType">
            <option value="" disabled selected>
              {{ $t("navigations.select") }}
            </option>
            <template v-for="classification in classficationList">
              <template
                v-if="classification.classifier === 'Study Design (Allocation)'"
              >
                <option
                  v-for="studyType in classification.classifications"
                  :key="studyType"
                >
                  {{ studyType }}
                </option>
              </template>
            </template>
          </select>
        </div>
         <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{
            $t("navigations['study version']")
          }}<sup><i class="fa fa-asterisk imp"></i></sup
          ></label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.version"
          />
          <span class="errormsg" v-if="errors[2] == false">{{
            $t("navigations.please enter a version")
          }}</span>
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{
            $t("navigations['expected no of patients']")
          }}</label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.numberOfPatient"
            @change.prevent="numberonlyvalidation('numberOfPatient')"
          />
          <span class="errormsg" v-if="numerrors['numberOfPatient'] == false">{{
            $t("navigations.please enter a number")
          }}</span>
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{
            $t("navigations['expected no of sites']")
          }}</label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.numberOfSite"
            @change.prevent="numberonlyvalidation('numberOfSite')"
          />
          <span class="errormsg" v-if="numerrors['numberOfSite'] == false">{{
            $t("navigations.please enter a number")
          }}</span>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.allocation") }}
          </label>
          <select class="form-select" v-model="allocation">
            <option value="" disabled selected>
              {{ $t("navigations.select") }}
            </option>

            <template v-for="classification in classficationList">
              <template v-if="classification.classifier === 'Allocation'">
                <option
                  v-for="allocation in classification.classifications"
                  :key="allocation"
                >
                  {{ allocation }}
                </option>
              </template>
            </template>
          </select>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.intervention model") }}
          </label>
          <select class="form-select" v-model="intervention">
            <option value="" disabled selected>
              {{ $t("navigations.select") }}
            </option>
            <template v-for="classification in classficationList">
              <template
                v-if="
                  classification.classifier ===
                  'Nature of Interventions or Exposures'
                "
              >
                <option
                  v-for="intervention in classification.classifications"
                  :key="intervention"
                >
                  {{ intervention }}
                </option>
              </template>
            </template>
          </select>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">{{ $t("navigations.masking") }} </label>
          <select class="form-select" v-model="masking">
            <option value="" disabled selected>
              {{ $t("navigations.select") }}
            </option>
            <template v-for="classification in classficationList">
              <template v-if="classification.classifier === 'Masking'">
                <option
                  v-for="masking in classification.classifications"
                  :key="masking"
                >
                  {{ masking }}
                </option>
              </template>
            </template>
          </select>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.primary purpose") }}
          </label>
          <select class="form-select" v-model="purpose">
            <option value="" disabled selected>
              {{ $t("navigations.select") }}
            </option>
            <template v-for="classification in classficationList">
              <template v-if="classification.classifier === 'Primary Purpose'">
                <option
                  v-for="purpose in classification.classifications"
                  :key="purpose"
                >
                  {{ purpose }}
                </option>
              </template>
            </template>
          </select>
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label">{{
            $t("navigations.official title")
          }}</label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="title"
          />
        </div>
        <div class="col-lg-4 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.study notes") }}
          </label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.studyNotes"
          />
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">
            {{ $t("navigations.pre-visit") }}</label
          >
          <input
            type="text"
            class="form-control"
            maxlength="4"
            v-model="values.preVisit"
            @change.prevent="numberonlyvalidation('preVisit')"
          />
          <span class="errormsg" v-if="numerrors['preVisit'] == false">{{
            $t("navigations.please enter a number")
          }}</span>
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.post-visit") }}
          </label>
          <input
            type="text"
            class="form-control"
            maxlength="4"
            v-model="values.postVisit"
            @change.prevent="numberonlyvalidation('postVisit')"
          />
          <span class="errormsg" v-if="numerrors['postVisit'] == false">{{
            $t("navigations.please enter a number")
          }}</span>
        </div>

        <div class="col-lg-3 mb-1">
          <label class="col-form-label"
            >{{ $t("navigations.duration (year)") }}
          </label>
          <input
            type="text"
            class="form-control"
            maxlength="1000"
            v-model="values.duration"
            @change.prevent="numberonlyvalidation('duration')"
          />
          <span class="errormsg" v-if="numerrors['duration'] == false">{{
            $t("navigations.please enter a number")
          }}</span>
        </div>
        <div class="col-lg-3 mb-1">
          <label class="col-form-label">{{ $t("navigations.status") }}</label>
          <select
            v-if="selectedstudy == 0"
            class="form-select"
            name="account"
            v-model="values.status"
          >
            <option value="New">New</option>
          </select>
          <select
            v-else
            class="form-select"
            name="account"
            v-model="values.status"
          >
            <option value="Archived">Archived</option>
            <option value="Closed">Closed</option>
            <option value="New">New</option>
            <option value="Open">Open</option>
          </select>
        </div>

        <div class="col-lg-4 mt-2 d-flex">
          <div>
            <div>
              <label class="mr-2 mb-0">{{ $t("navigations.active") }}</label>
              <input type="checkbox" v-model="values.active" />
            </div>
          </div>
        </div>
        <div class="col-lg-12 my-3 d-flex justify-content-lg-end">
          <button
            class="cancel_btn py-1 px-4 mx-3"
            type="button"
            @click.prevent="clear"
          >
            {{ $t("navigations.clear") }}
          </button>
          <button
            class="save_btn py-1 px-4"
            type="submit"
            @click.prevent="addStudy"
          >
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./studyComponent.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/savepages.css";
.wrapper-content {
  width: 100%;
}
textarea {
  width: 100%;
}
.imp {
  color: #ff0000;
  font-size: 7px;
}
.col-form-label {
  font-size: 12px;
}
.impcl {
  color: #ff4747;
  font-size: 25px;
  float: right;
}
.impcl:hover {
  color: #a30202;
  font-size: 25px;
  float: right;
}
.errormsg {
  color: red;
  font-size: 15px;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
</style>